// eslint-disable-next-line import/prefer-default-export
export const donateManual =
    "https://www.canva.com/design/DAGFuOpQHcs/UlGbcie5raQITX8Fm5ZxDw/view?utm_content=DAGFuOpQHcs&utm_campaign=designshare&utm_medium=link&utm_source=editor";
